// removed by extract-text-webpack-plugin
module.exports = {"form":"_53FBH-tS6OWn5WDZUrYwT","inputField":"cpn1-iYAPtdn_Yx_N6mVm","error":"_3QzqAq2wNWQRm95Qw7nIxM","loginBtn":"jjpN4GsGKWnbHLbZvxYxX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/style.css
// module id = 273
// module chunks = 0